/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Cmp_Codecs_LabelInputs */

const en_fc_cmp_codecs_label = /** @type {(inputs: Fc_Cmp_Codecs_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codecs`)
};

/**
* | output |
* | --- |
* | "Codecs" |
*
* @param {Fc_Cmp_Codecs_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_cmp_codecs_label = /** @type {((inputs?: Fc_Cmp_Codecs_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Cmp_Codecs_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_cmp_codecs_label(inputs)
});
export { fc_cmp_codecs_label as "fc.cmp.codecs.label" }